import { LeadData, PostLeadResponse, Lead } from 'modules/lead/types'

export const EMPTY_POST_LEAD_RESPONSE: PostLeadResponse = {
  contactId: '',
  email: '',
  isInWindowTime: false,
  isParticipant: false,
  name: '',
  schedule: ''
}

export const EMPTY_LEAD_DATA: LeadData = {
  email: '',
  name: '',
  schedule: '',
  photo: ''
}

export const EMPTY_LEAD: Lead = {
  email: '',
  name: '',
  schedule: '',
  photo: '',
  color: '',
  sparkieUserId: '',
  contactId: ''
}
